/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowDraftConfigurationsQueryResponse, GetShowDraftConfigurationsPathParams, GetShowDraftConfigurationsQueryParams, GetShowDraftConfigurations401, GetShowDraftConfigurations403 } from "../../models/GetShowDraftConfigurations";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowDraftConfigurationsUrl({ debtorCode }: { debtorCode: GetShowDraftConfigurationsPathParams["debtorCode"] }) {
  const res = { method: 'GET', url: `/api/v1/debtors/${debtorCode}/draft-configurations` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/draft-configurations}
 */
export async function getShowDraftConfigurations({ debtorCode, params }: { debtorCode: GetShowDraftConfigurationsPathParams["debtorCode"]; params: GetShowDraftConfigurationsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowDraftConfigurationsQueryResponse, ResponseErrorConfig<GetShowDraftConfigurations401 | GetShowDraftConfigurations403>, unknown>({ method : "GET", url : getGetShowDraftConfigurationsUrl({ debtorCode }).url.toString(), params, ... requestConfig })  
  return res.data
}